/**
 * Wholesale Size Categories API Client
 */

import apiClient from '../client';

const BASE_URL = '/wholesale/size-categories';

// ===== GET ALL =====

/**
 * Get all size categories
 */
export const getSizeCategories = async (includeInactive = false) => {
  try {
    const response = await apiClient.get(BASE_URL, {
      params: { includeInactive }
    });
    return response.data?.data || response.data || [];
  } catch (error) {
    console.error('Error fetching size categories:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch size categories',
      status: error.response?.status,
    };
  }
};

// ===== GET BY ID =====

/**
 * Get size category by ID
 */
export const getSizeCategoryById = async (id) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/${id}`);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error fetching size category:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch size category',
      status: error.response?.status,
    };
  }
};

// ===== CREATE =====

/**
 * Create a new size category
 */
export const createSizeCategory = async (data) => {
  try {
    const response = await apiClient.post(BASE_URL, data);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error creating size category:', error);
    throw {
      message: error.response?.data?.error || 'Failed to create size category',
      status: error.response?.status,
    };
  }
};

// ===== UPDATE =====

/**
 * Update a size category
 */
export const updateSizeCategory = async (id, data) => {
  try {
    const response = await apiClient.patch(`${BASE_URL}/${id}`, data);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error updating size category:', error);
    throw {
      message: error.response?.data?.error || 'Failed to update size category',
      status: error.response?.status,
    };
  }
};

// ===== DELETE =====

/**
 * Delete a size category
 */
export const deleteSizeCategory = async (id) => {
  try {
    const response = await apiClient.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting size category:', error);
    throw {
      message: error.response?.data?.error || 'Failed to delete size category',
      status: error.response?.status,
    };
  }
};

// ===== REORDER =====

/**
 * Reorder size categories
 */
export const reorderSizeCategories = async (orderedIds) => {
  try {
    const response = await apiClient.post(`${BASE_URL}/reorder`, { orderedIds });
    return response.data;
  } catch (error) {
    console.error('Error reordering size categories:', error);
    throw {
      message: error.response?.data?.error || 'Failed to reorder size categories',
      status: error.response?.status,
    };
  }
};

export default {
  getSizeCategories,
  getSizeCategoryById,
  createSizeCategory,
  updateSizeCategory,
  deleteSizeCategory,
  reorderSizeCategories,
};
